import vueMainInstance from "../../main";

const namespaced = true;

// You can use it as state property
const state = {
  vehicles: [],
  isVehicleEditing: false,
  vehicleEdited: {
    id: null,
    plates: "",
    model: "",
    engine_capacity: "",
    type: null,
    is_private: false
  },
  vehicleBeforeEdit: null,
  status: ""
};

// You can use it as a state getter function (probably the best solution)
const getters = {
  vehicleList: state => state.vehicles,
  isVehicleEditing: state => state.isVehicleEditing,
  vehicleEdited: state => state.vehicleEdited
};

// Mutation for when you use it as state property
const mutations = {
  editVehicle(state, vehicle) {
    state.vehicleEdited = vehicle;
  },
  addVehicleToList(state, vehicle) {
    state.vehicles.push(vehicle);
  },

  setVehicleList(state, vehicleList) {
    state.vehicles = vehicleList;
  },

  setVehicleEditing(state, vehicle) {
    state.vehicleEdited = vehicle;
    state.isVehicleEditing = true;
    state.vehicleBeforeEdit = JSON.parse(JSON.stringify(vehicle));
  },

  setEditionComplete(state, vehicle) {
    if (vehicle != null) {
      state.vehicleEdited = vehicle;
    } else {
      //set back properties if no "save" pressed
      for (var property in state.vehicleEdited) state.vehicleEdited[property] = state.vehicleBeforeEdit[property];
    }
    state.isVehicleEditing = false;
  },
  removeVehicle(state, vehicle) {
    const index = state.vehicles.indexOf(vehicle);
    state.vehicles.splice(index, 1);
  }
};

const actions = {
  loadAllVehicles({ commit }) {
    vueMainInstance.axios.get("vehicle/list").then(response => {
      commit("setVehicleList", response.data);
    });
  },
  editVehicle({ commit }, vehicle) {
    commit("setVehicleEditing", vehicle);
  },
  saveEditedVehicle({ commit }, vehicle) {
    vueMainInstance.axios
      .post("vehicle/save", vehicle)
      .then(resp => {
        if (resp.data.status === "ok") {
          if (vehicle.id == null) {
            vehicle.id = resp.data.vehicle.id;
            commit("addVehicleToList", vehicle);
          }
          commit("setEditionComplete", vehicle);
        } else if (resp.data.status === "error") {
          //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
        }
      })
      .catch(() => {
        //TODO obsluga bledow
      });
  },
  cancelEdition({ commit }) {
    commit("setEditionComplete", null);
  },
  resumeOrNewVehicle({ commit }) {
    const vehicle = {
      id: null,
      plates: "",
      model: "",
      engine_capacity: "",
      type: null,
      is_private: false
    };
    commit("setVehicleEditing", vehicle);
  },

  removeVehicle({ commit, dispatch }, vehicle) {
    vueMainInstance.axios
      .post("vehicle/delete", vehicle)
      .then(resp => {
        if (resp.data.status === "ok") {
          commit("removeVehicle", vehicle);
          dispatch(
            "snackbarPush",
            {
              text: vueMainInstance.$t("global.deleted")
            },
            { root: true }
          );
        } else if (resp.data.status === "error") {
          //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
        }
      })
      .catch(() => {
        //TODO obsluga bledow
      });
  }
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
